import { render, staticRenderFns } from "./contact_product_data.vue?vue&type=template&id=825b7260&"
import script from "./contact_product_data.vue?vue&type=script&lang=js&"
export * from "./contact_product_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports